import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "tooltip", "hideArrow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import TooltipTrigger from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Tooltip = function Tooltip(_ref) {
  var _children = _ref.children,
      _tooltip = _ref.tooltip,
      _ref$hideArrow = _ref.hideArrow,
      hideArrow = _ref$hideArrow === void 0 ? false : _ref$hideArrow,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(TooltipTrigger, _objectSpread(_objectSpread({}, props), {}, {
    tooltip: function tooltip(_ref2) {
      var arrowRef = _ref2.arrowRef,
          tooltipRef = _ref2.tooltipRef,
          getArrowProps = _ref2.getArrowProps,
          getTooltipProps = _ref2.getTooltipProps,
          placement = _ref2.placement;
      return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getTooltipProps({
        ref: tooltipRef,
        className: 'tooltip-container bg-black text-white font-sans max-w-xs w-48 rounded'
      })), {}, {
        children: [!hideArrow && /*#__PURE__*/_jsx("div", _objectSpread({}, getArrowProps({
          ref: arrowRef,
          className: 'tooltip-arrow',
          'data-placement': placement
        }))), /*#__PURE__*/_jsx("span", {
          className: "text-sm",
          children: _tooltip
        })]
      }));
    },
    children: function children(_ref3) {
      var getTriggerProps = _ref3.getTriggerProps,
          triggerRef = _ref3.triggerRef;
      return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, getTriggerProps({
        ref: triggerRef,
        className: 'trigger ml-1 self-center'
      })), {}, {
        children: _children
      }));
    }
  }));
};

export default Tooltip;